import { Currency } from '@kodiak-finance/sdk-core'
import { QUOTE_TOKEN_PRIORITY_LIST } from 'constants/lists'

export const getQuoteCurrency = (currencyA: Currency | null | undefined, currencyB: Currency | null | undefined) => {
  if (currencyA && currencyB) {
    const aPriority = QUOTE_TOKEN_PRIORITY_LIST[currencyA.symbol || 'NA'] || 0
    const bPriority = QUOTE_TOKEN_PRIORITY_LIST[currencyB.symbol || 'NA'] || 0
    return aPriority > bPriority ? currencyA : currencyB
  }
  return currencyA || currencyB
}
